import { render, staticRenderFns } from "./ManageCurrencies.vue?vue&type=template&id=2cff847d"
import script from "./ManageCurrencies.vue?vue&type=script&lang=js"
export * from "./ManageCurrencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports